import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import FlyerPrintButton from './FlyerPrintButton';
import { Flyer } from '../../../Enums/Flyer.enum';

loadDOMComponent({
	selector: 'react-flyer-print-button',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const workplaceMemberId = container.getAttribute('workplaceMemberId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<FlyerPrintButton
						workplaceId={workplaceId}
						workplaceMemberId={workplaceMemberId}
						flyerType={Flyer.E_ARCHIVE}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
